export enum ShippingMethodType {
  Custom,
  Standard,
  Express,
  SameDay,
  Overnight
}
